import { useContext, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { makeStyles } from '@mui/styles';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
import PageLoading from '@classify/react-core-components/PageLoading';
import { alpha } from '@classify/react-core-components/styles';
import Box from '@classify/react-core-components/Box';

import CourseChapterHeader from '../components/CourseChapterHeader';
import TocToggler from '../components/TableOfContent/TocToggler';
import CourseContext from '../contexts/courseContext';
import QuizAnonymous from '../components/QuizAnonymous';

type RouteParams = {
  exerciseId: string;
};

const useStyles = makeStyles(() => ({
  contentWrapper: {
    position: 'relative',
  },
}));

const CourseExerciseScreen = () => {
  const classes = useStyles();
  const drawerContainerRef = useRef<HTMLDivElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);
  const [isTocOpen, setIsTocOpen] = useState(false);

  const { course, isLoadingUserToc } = useContext(CourseContext);
  const { exerciseId: exerciseIdParam } = useParams<RouteParams>();

  if (!course || isLoadingUserToc) {
    return <PageLoading pastDelay />;
  }

  return (
    <div
      style={{
        '--categoryColor': course.categoryColor,
        '--hoverBackgroundColor': alpha(course.categoryColor, 0.24),
      }}
    >
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>

      <CourseChapterHeader headerRef={headerRef} />

      <Box ref={drawerContainerRef} sx={{ display: 'flex', position: 'relative', pb: 2 }}>
        <TocToggler headerRef={headerRef} isOpen={isTocOpen} setIsOpen={setIsTocOpen} />

        <ContentWrapper variant="narrow" className={classes.contentWrapper}>
          <QuizAnonymous exerciseId={Number(exerciseIdParam)} />
        </ContentWrapper>
      </Box>
    </div>
  );
};

export default CourseExerciseScreen;
